module.exports = __webpack_public_path__ + "static/img/shop_storage_1.7ba21fdb.jpg";